import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, Input, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalComponent } from 'src/app/custom-component/modal/modal.component';
import { ActivatedRoute } from '@angular/router';
import { TalkToSalesButtonComponent } from 'src/app/shared/components/talktosalesButton/talktosalesButton.component';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';

@Component({
  selector: 'app-custom-getstarted',
  templateUrl: './getstarted.component.html',
  imports: [CommonModule, TalkToSalesButtonComponent, UrlParamsPipe],
})
export class CustomGetstartedComponent implements OnInit, OnDestroy {
  @Input() getStartedData: any;
  @ViewChild('registerLink') registerLink: any;
  queryParams: any;
  constructor(
    private route: ActivatedRoute
  ) {
    this.subscriptions = [];
    this.route.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  _getStartedData: any;

  ngOnInit(): void {
    this._getStartedData = this.getStartedData;
  }
  ngOnChanges(): void {
    this._getStartedData = this.getStartedData;
  }
}
